<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formInventoryTransfer">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="'Imprimir'" [severity]="'contrast'" [icon]="'pi pi-print'"
                (onClick)="printPage()"></app-custom-button>
              <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)="deleteInventoryTransfer()"></app-custom-button>

              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [severity]="'success'" [variant]="undefined" [width]="'5.5rem'"
                (onClick)="createNewInventoryTransfer()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="inventoryTransferModel.userNameCreate"
                [createDate]="inventoryTransferModel.createDate"
                [userNameUpdate]="inventoryTransferModel.userNameUpdate"
                [updateDate]="inventoryTransferModel.updateDate"
                [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row d-flex justify-content-between">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-2 col-md-3 col-sm-6 col-12">
                  <app-custom-select formControlName="inventoryId" [labelText]="'Inventario'" [list]="listInventories"
                    [required]="true" [recovery]="true" (onChangeSelect)="getInventory($event, true)">
                  </app-custom-select>
                </div>
                <div class="col-lg-1 col-md-2 col-sm-2 col-6">
                  <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                    [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-4 col-6">
                  <app-custom-select formControlName="type" [labelText]="'Tipo'" [list]="listTypes" [required]="true"
                    (onChangeSelect)="changeValues()"></app-custom-select>
                </div>
                <div class="col-lg-1 col-md-2 col-sm-3 col-6">
                  <app-custom-datepicker formControlName="dateOutput" [labelText]="'Fecha Envío'" [required]="true"
                    (onChangeDate)="changeValues()"></app-custom-datepicker>
                </div>
                <div class="col-lg-1 col-md-2 col-sm-3 col-6">
                  <app-custom-datepicker formControlName="dateEntry" [labelText]="'Fecha Recepción'" [required]="true"
                    (onChangeDate)="changeValues()"></app-custom-datepicker>
                </div>
                <div class="col-lg-1 col-md-2 col-sm-2 col-4">
                  <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateText"></app-custom-tag>
                </div>
                <div class="col-lg-1 col-md-2 col-sm-2 col-4 d-flex align-items-end gap-2">
                  <app-custom-button [disabled]="disabledState" [icon]="iconStateButton" [title]="titleStateButton"
                    [severity]="'primary'" (onClick)="changeState()"></app-custom-button>
                  <app-custom-button *ngIf="swConfirmTransfer" [disabled]="disabledConfirmTransfer"
                    [icon]="'pi pi-check-circle'" [severity]="'success'" [title]="'Confirmar'"
                    (onClick)="confirmTransfer()"></app-custom-button>
                  <app-custom-button [disabled]="disabledState" [title]="'Anular Traslado'" [icon]="'pi pi-ban'"
                    [severity]="'warn'" (onClick)="annulInventoryTransfer()"></app-custom-button>
                </div>
                <div
                  class="col-lg-3 col-md-6 col-sm-12 col-12 my-md-0 my-3 d-flex justify-content-md-end align-items-end gap-2">
                  <app-custom-chip *ngIf="consecutiveOutput" [label]="'Salida: ' + consecutiveOutput" />
                  <app-custom-chip *ngIf="consecutiveEntry" [label]="'Entrada: ' + consecutiveEntry" />
                  <app-custom-chip *ngIf="siesaSynchronization"
                      [label]="'Envío Siesa: ' + (inventoryTransferModel.sendDateAccounting ? (inventoryTransferModel.sendDateAccounting | date: 'dd/MM/yyyy hh:mm:ss') : '')"  />
                </div>
                <div class="col-lg-2 col-md-5 col-sm-6 col-12">
                  <app-custom-select formControlName="branchOutputId" [labelText]="'Sucursal Envío'"
                    [list]="listBranches" [required]="true"
                    (onChangeSelect)="getBranch($event, true)"></app-custom-select>
                </div>
                <div class="col-lg-4 col-md-5 col-sm-6 col-12">
                  <app-custom-autocomplete formControlName="storeOutputId" [labelText]="'Bodega Envío'"
                    [list]="listStoresOutput" [required]="true" (onChangeNumber)="changeValues()">
                  </app-custom-autocomplete>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-6 col-12">
                  <app-custom-select formControlName="branchEntryId" [labelText]="'Sucursal Recepción'"
                    [list]="listBranches" [required]="true"
                    (onChangeSelect)="getBranch($event, false)"></app-custom-select>
                </div>
                <div class="col-lg-4 col-md-5 col-sm-6 col-12">
                  <app-custom-autocomplete formControlName="storeEntryId" [labelText]="'Bodega Recepción'"
                    [list]="listStoresEntry" [required]="true" (onChangeNumber)="changeValues()">
                  </app-custom-autocomplete>
                </div>
                <div class="col-lg-3 col-md-2 col-sm-6 col-12">
                  <app-custom-select formControlName="transporterId" [labelText]="'Transportador'"
                    [list]="listTransporters" [required]="true" (onChangeNumber)="changeValues()">
                  </app-custom-select>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-6 col-12">
                  <app-custom-select formControlName="vehicleId" [labelText]="'Vehículo'" [list]="listVehicles"
                    [required]="true" (onChangeNumber)="changeValues()">
                  </app-custom-select>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-3 col-6">
                  <app-custom-input-number formControlName="transportValue" [labelText]="'Vr.Trans a pagar'"
                    [required]="true" (onChangeNumber)="changeValues()"></app-custom-input-number>
                </div>
                <div class="col-lg-4 col-md-5 col-sm-12 col-12">
                  <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
                    [maxLength]="250"></app-custom-textarea>
                </div>
                <div class="col-lg-1 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-2">
                  <app-custom-button [label]="'Guardar'" [severity]="'primary'" [disabled]="disabledForm"
                    (onClick)="send()"></app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 container-style mt-2">
    <app-inventory-transfer-detail [inventoryTransferModel]="inventoryTransferModel" [disabledDetail]="disabledDetail"
      (emitQuantityDetails)="quantityDetails = $event">
    </app-inventory-transfer-detail>
  </div>
</section>

<app-print-inventory-transfer id="print-inventory-transfer" [companyId]="companyId" [formatModel]="formatModel"
  [focusText]="false" [editFormat]="false" [inventoryTransferModel]="inventoryTransferPrintModel"
  (finishLoadingPrint)="finishLoading($event)">
</app-print-inventory-transfer>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>